module.exports = __webpack_public_path__ + "static/media/18.9f3691c7.jpg";